(function () {
	'use strict';
	angular.module('mx.SolutionBuilderAgent').component('mxComplianceRuleConditionsBuilder', {
		bindings: {
			value: '<',
			value2: '=?',
			value3: '=?',
			typeIds: '=?value4',
			disabledAdd: '<value5',
		},
		controller: MxComplianceRuleConditionsBuilderCtrl,
		controllerAs: 'vm',
		template: '<mx-conditions-builder conditions-builder="vm.builder" ng-if="vm.builder && vm.builder.properties.length>0">',
	});

	MxComplianceRuleConditionsBuilderCtrl.$inject = ['$scope', 'mx.SolutionBuilderAgent.ComplianceRuleConditionsService'];

	function MxComplianceRuleConditionsBuilderCtrl($scope, complianceRuleConditionsService) {
		var vm = this;
		var currentTrigger;
		var currentRelatedClasses;
		var firstInit = true;
		var propertiesPromise, builderPromise;
		var currentIsBasedOnDD = false;

		vm.$onInit = function () {};

		$scope.$watchCollection('vm.value.RelatedClasses', function (relatedClasses) {
			initBuilder(currentTrigger, relatedClasses, currentIsBasedOnDD);
		});

		$scope.$watchCollection('vm.value.IsBasedOnDD', function (isBasedOnDD) {
			initBuilder(currentTrigger, currentRelatedClasses, isBasedOnDD);
		});

		$scope.$watch('vm.value.ConditionType', function (newTrigger) {
			initBuilder(newTrigger, currentRelatedClasses, currentIsBasedOnDD);
		});

		vm.$onChanges = function (changes) {
			if (vm.builder && changes.disabledAdd) {
				vm.builder.disabledAdd = changes.disabledAdd.currentValue;
			}
		};

		function initBuilder(trigger, relatedClasses, isBasedOnDD = false) {
			const propertiesInputAttributesChanged = !angular.equals(currentRelatedClasses, relatedClasses) || isBasedOnDD !== currentIsBasedOnDD || trigger !== currentTrigger;

			currentIsBasedOnDD = isBasedOnDD;
			currentRelatedClasses = relatedClasses;
			currentTrigger = trigger;

			propertiesPromise = !propertiesInputAttributesChanged
				? propertiesPromise
				: complianceRuleConditionsService.getProperties({
						relatedClasses: currentRelatedClasses,
						trigger: trigger,
						typeIds: vm.typeIds || [],
						isBasedOnDD: currentIsBasedOnDD,
				  });

			return propertiesPromise
				.then(function (properties) {
					vm.value3 = properties;

					if (typeof trigger === 'undefined' || !Array.isArray(relatedClasses) || !relatedClasses.length) {
						return;
					}

					if (!propertiesInputAttributesChanged) {
						return builderPromise;
					}

					var conditions = firstInit && Array.isArray(vm.value2) ? vm.value2 : [];
					builderPromise = complianceRuleConditionsService.getBuilder({ trigger: trigger, conditions: conditions, typeIds: vm.typeIds || [], isBasedOnDD: isBasedOnDD });
					firstInit = false;

					return builderPromise;
				})
				.then(function (builder) {
					vm.builder = builder;

					if (builder) {
						vm.builder.onOutputChange = onOutputChange;
						vm.builder.properties = vm.value3;
						vm.builder.disabledAdd = vm.disabledAdd;
					}
					return builder;
				});
		}

		function onOutputChange(output) {
			if (vm.value2 instanceof mx.SolutionBuilderAgent.DataModelArray) {
				vm.value2.set(output);
			} else if (Array.isArray(vm.value2)) {
				vm.value2.splice.apply(vm.value2, [0, vm.value2.length].concat(output));
			} else {
				vm.value2 = output;
			}
		}
	}
})();
